/**
 * SalonPlaniDuzenlePage.jsx — bir fuar alanındaki salonun Salon Planı'nı TAM DÜZENLEME modunda,
 * kendi sayfasında açar (backlog #193, 2026-09-26).
 * Route: /Management/FairAreas/:fuarAlaniId/Salonlar/:salonId/Plan
 *
 * Açıldığı yer: FuarAlaniSalonlariCard'daki kalem düğmesi (Fuar Alanları › Salonlar ve Fuar Alanı
 * Detay › Salonlar). Aynı karttaki harita düğmesi salt okunur hızlı bakış modalı olarak kaldı.
 * Bu sayfa hazır olunca Fuar Alanı Detay'ın "Krokiler" sekmesi kaldırıldı (yorum satırı).
 *
 * fdsvector tarafı: /embed/hall-floor-plan?fairgroundId&hallId&mode=edit&activeLayer=…
 * (hall-base dokümanı, fuar alanı + salon ile çözülür; o fuar alanındaki HER fuar aynı planı
 * paylaşır). activeLayer backlog #205: floorplan = Salon Planı, infrastructure = Altyapı Planı.
 *
 * ⚠️ Edit modunda açmak, belge yoksa fdsvector'de OLUŞTURUR (POST /api/documents/hall-base).
 *    KrokiVectorEmbed bu yüzden normalde "Krokiyi Aç" tıklaması bekler; burada autoOpen ile
 *    atlanıyor, ama YALNIZCA salon bu fuar alanında kayıtlı çıkarsa (GET /fuar/alani/{id} —
 *    uydurma bir URL ile boş doküman birikmesin).
 * ⚠️ Salon Planı ve Altyapı Planı fdsvector'de KORUMALI katmanlar: sunucu yalnızca ADMIN/MİMAR
 *    rolünün yazmasına izin verir. FDS-Backend fdsvector'ün okuduğu rol listesini
 *    (user_group.user_roles) hiç göndermediği için fdsvector rolü "bilinmiyor" görür ve bugün
 *    HERKESE izin verir (fail-open, backlog #29/#193). Bu yüzden erişim burada, FDS tarafında
 *    kısıtlanıyor: rota [1,2,3] + yalnızca personel (Bilge, 2026-09-26). Gerçek RBAC ayrı iş.
 *    Backlog #219 (fdsvector bd876b2): roller gelmeye başlayınca fdsvector, ADMIN/MİMAR olmayan
 *    bir kullanıcıya activeLayer=floorplan|infrastructure'ı açmaz — plan varsayılan katmanda,
 *    bir uyarıyla açılır. Bugün roller boş olduğu için davranış değişmedi.
 *
 * Backlog #228 (2026-09-27, Bilge): katman SAYFAYA SABİT. Hangi katmanda çalışılacağı plan
 * yüklenmeden ÖNCE belli olmalı ve parametreyle gelmeli: ?katman=floorplan | infrastructure
 * zorunlu. Geçerli bir katman yoksa iframe yüklenmez; önce iki düğmeli seçici çıkar (Salon Planı /
 * Altyapı Planı). WAS: katman verilmezse sessizce floorplan açılıyordu ve başlıktaki "Açılış
 * katmanı" düğmeleri iframe'i öbür katmanda yeniden yüklüyordu — o seçici yorum satırında.
 * Katmanı değiştirmek için geri dönüp yeniden seçilir. fdsvector'e edit modunda layers=<katman> ve
 * lockLayer=1 gider (krokiVectorService.buildEmbedUrl) — fdsvector bunları #227 / #229 gelince
 * uygular (katman değiştirme kapalı, kenar çubuğunda yalnızca bu katman); o zamana kadar yok sayar.
 */
import React, { useCallback, useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
// WAS: … Button, ButtonGroup, … — ButtonGroup yalnızca yorum satırına alınan "Açılış katmanı" içindi (#228).
import {
  Container, Card, CardBody, Row, Col, Button, Spinner, Alert, Badge,
} from "reactstrap";
import { ArrowLeft, Layers } from "lucide-react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import KrokiVectorEmbed from "../../../Components/Kroki/KrokiVectorEmbed";
import { KROKI_LAYERS, KROKI_MODES } from "../../../services/krokiVectorService";
import {
  getFuarAlani, setSalonPlaniDurumu, setAltyapiPlaniDurumu,
} from "../../../services/fuarAlaniSalonService";
import { isStaffAccount } from "../../../services/firmaSessionService";
import { CizimDurumuPill } from "../../../Components/FairAreas/salonDurumlari";
import { useTranslation } from "react-i18next";
import i18n from "../../../i18n";

const ACILIS_KATMANLARI = [
  { key: KROKI_LAYERS.FLOORPLAN, get label() { return i18n.t("yonetim:salonPlaniDuzenle.salonPlani"); }, plan: "salonPlani", get aciklama() { return i18n.t("yonetim:salonPlaniDuzenle.salonDuvarlariVeSinirlari"); } },
  { key: KROKI_LAYERS.INFRASTRUCTURE, get label() { return i18n.t("yonetim:salonPlaniDuzenle.altyapiPlani"); }, plan: "altyapiPlani", get aciklama() { return i18n.t("yonetim:salonPlaniDuzenle.elektrikSuHavaHatlari"); } },
];

export default function SalonPlaniDuzenlePage() {
  const { t: tx } = useTranslation("yonetim");
  const { fuarAlaniId, salonId } = useParams();
  // ?katman=floorplan | infrastructure — ZORUNLU (#228). Salon Kartı'ndaki "Düzenle" bağlantıları
  // (#163) ve Salonlar'daki rozetler (#204/#234) katmanı verir; vermeyen bağlantı seçiciye düşer.
  // WAS: const [searchParams] = useSearchParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const istenenKatman = searchParams.get("katman");
  const personel = isStaffAccount();

  const [fuarAlaniName, setFuarAlaniName] = useState(null);
  const [hall, setHall] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  // WAS: const [katman, setKatman] = useState(
  //   ACILIS_KATMANLARI.some((k) => k.key === istenenKatman) ? istenenKatman : KROKI_LAYERS.FLOORPLAN,
  // );
  // #228: katman adresten türetilir; geçersiz / eksikse null → seçici (sessiz floorplan yok).
  const katmanTanimi = ACILIS_KATMANLARI.find((k) => k.key === istenenKatman) ?? null;
  const katman = katmanTanimi?.key ?? null;
  const katmanSec = (key) => setSearchParams({ katman: key });
  const [busyPlan, setBusyPlan] = useState(null);

  useEffect(() => { document.title = i18n.t("yonetim:salonPlaniDuzenle.salonPlaniFds"); }, []);

  useEffect(() => {
    if (!successMsg) return undefined;
    const t = setTimeout(() => setSuccessMsg(null), 3500);
    return () => clearTimeout(t);
  }, [successMsg]);

  // KURAL: fetch Effect içindeki async fonksiyonda (react-hooks/set-state-in-effect).
  useEffect(() => {
    let ignore = false;
    async function run() {
      setLoading(true);
      setError(null);
      try {
        const alani = await getFuarAlani(fuarAlaniId);
        if (ignore) return;
        setFuarAlaniName(alani?.fuarAlaniName ?? null);
        const found = (alani?.halls ?? []).find((h) => String(h.salonId) === String(salonId)) ?? null;
        setHall(found);
      } catch (e) {
        if (!ignore) setError(e.status === 404 ? i18n.t("yonetim:salonPlaniDuzenle.fuarAlaniBulunamadi") : e.message);
      } finally {
        if (!ignore) setLoading(false);
      }
    }
    run();
    return () => { ignore = true; };
  }, [fuarAlaniId, salonId]);

  // WAS (#228'de kaldırıldı — katman sayfaya sabit, değiştirmek için geri dönüp yeniden seçilir):
  // // Açılış katmanını değiştirmek iframe'i yeniden yükler — kaydedilmemiş çizim kaybolur.
  // // Katmanlar arasında fdsvector'ün kendi sağ panelinden de geçilebilir; bu seçim yalnızca
  // // hangi katmanda AÇILACAĞINI belirler.
  // const changeKatman = (key) => {
  //   if (key === katman) return;
  //   // eslint-disable-next-line no-alert
  //   if (!window.confirm("Kroki bu katmanda yeniden açılacak. Kaydedilmemiş değişiklikler kaybolur. Devam edilsin mi?")) return;
  //   setKatman(key);
  // };

  const handleDurum = useCallback(async (plan, durum) => {
    setBusyPlan(plan);
    setError(null);
    try {
      const fn = plan === "altyapiPlani" ? setAltyapiPlaniDurumu : setSalonPlaniDurumu;
      const out = await fn(fuarAlaniId, salonId, durum);
      if (out?.data) setHall((h) => ({ ...h, ...out.data }));
      setSuccessMsg(out?.message || i18n.t("yonetim:salonPlaniDuzenle.cizimDurumuKaydedildi"));
    } catch (e) {
      setError(e.message);
    } finally {
      setBusyPlan(null);
    }
  }, [fuarAlaniId, salonId]);

  const backTo = `/Management/FairAreas/${fuarAlaniId}?tab=salonlar`;

  let govde;
  if (loading) {
    govde = <div className="text-center py-5"><Spinner color="primary" /></div>;
  } else if (!personel) {
    govde = <Alert color="warning" className="mb-0">{tx("salonPlaniDuzenle.salonPlaniDuzenlemeYalnizcaPersonel")}</Alert>;
  } else if (!hall) {
    // Kayıtlı olmayan bir salonla edit modunu açmak fdsvector'de boş bir doküman yaratırdı.
    govde = (
      <Alert color="warning" className="mb-0">
        {tx("salonPlaniDuzenle.salonBuFuarAlanindaKayitli", { salonId })}
        <Link to={backTo}>{tx("salonPlaniDuzenle.fuarAlanininSalonlarinaDon")}</Link>.
      </Alert>
    );
  } else if (!katman) {
    // #228: katman seçilmeden plan yüklenmez.
    govde = (
      <div className="py-3">
        <h6 className="mb-1">{tx("salonPlaniDuzenle.hangiKatmandaCalisilacak")}</h6>
        <p className="text-muted small mb-3">
          {istenenKatman
            ? <>{tx("salonPlaniDuzenle.adrestekiKatman")}<code>{istenenKatman}</code>{tx("salonPlaniDuzenle.taninmadi")}{" "}</>
            : null}
          {tx("salonPlaniDuzenle.planSecilenKatmandaAcilirVe")}
        </p>
        <Row className="g-3">
          {ACILIS_KATMANLARI.map((k) => (
            <Col key={k.key} md={6} xl={4}>
              <Button color="primary" outline className="w-100 text-start p-3" onClick={() => katmanSec(k.key)}>
                <div className="d-flex align-items-center gap-2 mb-1">
                  <Layers size={16} />
                  <span className="fw-semibold">{k.label}</span>
                  <span className="ms-auto">
                    <CizimDurumuPill
                      id={`plan-secici-${k.plan}`} plan={k.plan}
                      durum={hall[`${k.plan}Durum`] ?? 0} tarih={hall[`${k.plan}DurumTarihi`]}
                    />
                  </span>
                </div>
                <div className="small opacity-75">{k.aciklama}</div>
              </Button>
            </Col>
          ))}
        </Row>
      </div>
    );
  } else {
    govde = (
      <KrokiVectorEmbed
        fairgroundId={fuarAlaniId}
        hallId={hall.salonId}
        hallName={hall.salonName}
        defaultMode={KROKI_MODES.EDIT}
        allowEdit
        autoOpen
        activeLayer={katman}
        height="calc(100vh - 330px)"
      />
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title={tx("salonPlaniDuzenle.salonPlani")} pageTitle={tx("salonPlaniDuzenle.fuarAlanlari")} />

        {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}
        {successMsg && <Alert color="success">{successMsg}</Alert>}

        <Card className="mb-3">
          <CardBody className="py-2 d-flex align-items-center gap-3 flex-wrap">
            <Link to={backTo} className="btn btn-light btn-sm">
              <ArrowLeft size={14} className="me-1" />{tx("salonPlaniDuzenle.salonlar")}
            </Link>
            <div className="flex-grow-1">
              <h5 className="mb-0">
                {hall?.salonName ? tx("salonPlaniDuzenle.salon", { salonName: hall.salonName }) : tx("salonPlaniDuzenle.salon2", { salonId })}
                {katmanTanimi && <> — {katmanTanimi.label}</>}
                <Badge color="warning" pill className="ms-2 align-middle">{tx("salonPlaniDuzenle.duzenleme")}</Badge>
              </h5>
              <div className="text-muted small">{fuarAlaniName ?? tx("salonPlaniDuzenle.fuarAlani", { fuarAlaniId })}{" "}{tx("salonPlaniDuzenle.buFuarAlanindakiTumFuarlar")}</div>
            </div>
            {hall && personel && (
              <>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small">{tx("salonPlaniDuzenle.salonPlani")}</span>
                  <CizimDurumuPill
                    id="plan-sayfa-salon-plani" plan="salonPlani"
                    durum={hall.salonPlaniDurum ?? 0} tarih={hall.salonPlaniDurumTarihi}
                    busy={busyPlan === "salonPlani"} disabled={Boolean(busyPlan)}
                    onChange={(d) => handleDurum("salonPlani", d)}
                  />
                </div>
                <div className="d-flex align-items-center gap-2">
                  <span className="text-muted small">{tx("salonPlaniDuzenle.altyapiPlani")}</span>
                  <CizimDurumuPill
                    id="plan-sayfa-altyapi-plani" plan="altyapiPlani"
                    durum={hall.altyapiPlaniDurum ?? 0} tarih={hall.altyapiPlaniDurumTarihi}
                    busy={busyPlan === "altyapiPlani"} disabled={Boolean(busyPlan)}
                    onChange={(d) => handleDurum("altyapiPlani", d)}
                  />
                </div>
                {/* WAS (#228'de kaldırıldı — katman sayfaya sabit):
                <div className="d-flex align-items-center gap-2">
                  <Layers size={14} className="text-muted" />
                  <span className="text-muted small">Açılış katmanı</span>
                  <ButtonGroup size="sm">
                    {ACILIS_KATMANLARI.map((k) => (
                      <Button key={k.key} color="primary" outline={katman !== k.key} onClick={() => changeKatman(k.key)}>
                        {k.label}
                      </Button>
                    ))}
                  </ButtonGroup>
                </div>
                */}
                {katmanTanimi && (
                  <Badge color="light" className="text-dark border d-inline-flex align-items-center gap-1" title={tx("salonPlaniDuzenle.buSayfaBuKatmanaSabit")}>
                    <Layers size={12} />{tx("salonPlaniDuzenle.katman", { label: katmanTanimi.label })}
                  </Badge>
                )}
              </>
            )}
          </CardBody>
        </Card>

        <Card>
          <CardBody>{govde}</CardBody>
        </Card>
      </Container>
    </div>
  );
}
